<template>
    <!-- eslint-disable vue/no-v-html -->
    <div
        v-if="content"
        v-bind="$attrs"
        class="base-rich-text"
        v-html="content"
    />
    <!-- eslint-enable -->
    <div
        v-else
        class="base-rich-text"
        v-bind="$attrs"
    >
        <slot />
    </div>
</template>

<script setup>
defineProps({
    content: {
        type: String,
        default: ''
    }
});
</script>

<style lang="less" src="./BaseRichText.less"></style>
